import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tags',
  standalone: false,
})
export class TagsPipe implements PipeTransform {
  transform(value: string[]): string {
    if (value && Array.isArray(value)) {
      return value.map(item => `#${item}`).join(', ');
    }

    return '';
  }
}
